import * as o from "react";
import { p as l } from "./index-efd35e77.js";
import { A as O } from "./Animation-154b683d.js";
import { c as v, v as w, p as D } from "./package-metadata-a152adb8.js";
var P = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], j = (
  /** @class */
  function() {
    function n(t) {
      var a = this;
      this.rovingTabIndex = !0, this.update = function() {
      }, this.focusNextIndex = function(e, i) {
        var s = a.elements, r = s.indexOf(e) + i;
        r = r < 0 ? s.length - 1 : r, a.focusElement(s[r % s.length], e);
      }, this.tabIndex = t.tabIndex || 0, this.root = t.root, this.selectors = t.selectors, this.rovingTabIndex = t.rovingTabIndex !== void 0 ? t.rovingTabIndex : !0, this.mouseEvents = t.mouseEvents || {}, this.keyboardEvents = t.keyboardEvents || {};
    }
    return Object.defineProperty(n.prototype, "elements", {
      get: function() {
        return this.root.current ? Array.from(this.root.current.querySelectorAll(this.selectors.join(","))) : [];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "first", {
      get: function() {
        return this.root.current && this.root.current.querySelector(this.selectors.join(",")) || null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "last", {
      get: function() {
        var t = this.elements;
        return t[t.length - 1] || null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "current", {
      get: function() {
        return this.elements.find(function(t) {
          return t.matches(":focus");
        }) || null;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.focusNext = function(t) {
      this.focusNextIndex(t, 1);
    }, n.prototype.focusPrevious = function(t) {
      this.focusNextIndex(t, -1);
    }, n.prototype.triggerKeyboardEvent = function(t) {
      var a = t.target instanceof Element && t.target.closest(this.selectors.join(",")), e = t.key === " " ? "Space" : t.key, i = t.nativeEvent.type;
      a && this.keyboardEvents[i][e] && this.keyboardEvents[i][e].call(void 0, a, this, t);
    }, n.prototype.triggerMouseEvent = function(t) {
      var a = t.target instanceof Element && t.target.closest(this.selectors.join(",")), e = t.nativeEvent.type;
      a && this.mouseEvents[e].call(void 0, a, this, t);
    }, n.prototype.focusElement = function(t, a) {
      t && (a && (this.rovingTabIndex && a.removeAttribute("tabindex"), a.classList.remove("k-focus")), this.rovingTabIndex && t.setAttribute("tabindex", String(this.tabIndex)), t.focus({ preventScroll: !0 }));
    }, n;
  }()
), E = function(n) {
  var t = o.useRef(null), a = o.useCallback(function(e) {
    n.onClick && n.onClick.call(void 0, {
      syntheticEvent: e,
      item: n.item,
      title: n.title
    });
  }, [n.item, n.title, n.onClick]);
  return o.useEffect(function() {
    t.current && n.focused && t.current.focus();
  }, [n.focused]), o.createElement(
    "span",
    { style: n.style, tabIndex: n.tabIndex, className: v("k-actionsheet-item", "k-cursor-pointer", n.disabled && "k-disabled", n.className), ref: t, role: "button", "aria-disabled": n.disabled, onClick: a },
    o.createElement(
      "span",
      { className: "k-actionsheet-action" },
      n.icon && o.createElement("span", { className: "k-icon-wrap" }, n.icon),
      (n.title || n.description) && o.createElement(
        "span",
        { className: "k-actionsheet-item-text" },
        n.title && o.createElement("span", { className: "k-actionsheet-item-title" }, n.title),
        n.description && o.createElement("span", { className: "k-actionsheet-item-description" }, n.description)
      )
    )
  );
};
E.propTypes = {
  className: l.string,
  style: l.object,
  description: l.string,
  disabled: l.bool,
  group: l.oneOf(["top", "bottom"]),
  icon: l.element,
  title: l.string
};
var k = "ActionSheetHeader", x = function(n) {
  return o.createElement("div", { className: v("k-actionsheet-titlebar", n.className) }, n.children);
};
x.propTypes = {
  className: l.string
};
x.displayName = k;
x.propTypes = {
  children: l.any
};
var T = "ActionSheetFooter", N = function(n) {
  return o.createElement("div", { className: v("k-actionsheet-footer", n.className) }, n.children);
};
N.propTypes = {
  className: l.string
};
N.displayName = T;
N.propTypes = {
  children: l.any
};
var _ = "ActionSheetContent", S = function(n) {
  return o.createElement("div", { className: v("k-actionsheet-content", n.className) }, n.children);
};
S.propTypes = {
  className: l.string
};
S.displayName = _;
S.propTypes = {
  children: l.any
};
var R = globalThis && globalThis.__extends || function() {
  var n = function(t, a) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, i) {
      e.__proto__ = i;
    } || function(e, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (e[s] = i[s]);
    }, n(t, a);
  };
  return function(t, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
    n(t, a);
    function e() {
      this.constructor = t;
    }
    t.prototype = a === null ? Object.create(a) : (e.prototype = a.prototype, new e());
  };
}(), g = globalThis && globalThis.__assign || function() {
  return g = Object.assign || function(n) {
    for (var t, a = 1, e = arguments.length; a < e; a++) {
      t = arguments[a];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, g.apply(this, arguments);
}, K = globalThis && globalThis.__spreadArray || function(n, t, a) {
  if (a || arguments.length === 2)
    for (var e = 0, i = t.length, s; e < i; e++)
      (s || !(e in t)) && (s || (s = Array.prototype.slice.call(t, 0, e)), s[e] = t[e]);
  return n.concat(s || Array.prototype.slice.call(t));
}, M = (
  /** @class */
  function(n) {
    R(t, n);
    function t(a) {
      var e = n.call(this, a) || this;
      return e.actionSheetRef = o.createRef(), e.actionSheetTitleClass = "k-actionsheet-title", e.ariaLabeledBy = e.actionSheetTitleClass + 1, e.animationDuration = 300, e.bottomPosition = { bottom: "0", width: "100%" }, e.handleKeyDown = function(i) {
        e.props.navigatable && e.navigation.triggerKeyboardEvent(i);
      }, e.onTab = function(i, s, r) {
        r.preventDefault(), r.shiftKey ? s.focusPrevious(i) : s.focusNext(i);
      }, e.handleOverlayClick = function(i) {
        e.props.onOverlayClick && e.props.onOverlayClick.call(void 0, i), e.props.onClose && e.props.onClose.call(void 0, i), e.props.animation || e.hideActionSheet();
      }, e.handleItemClick = function(i) {
        e.props.onItemClick && e.props.onItemClick.call(void 0, i), e.props.onItemSelect && e.props.onItemSelect.call(void 0, i), e.props.animation || e.hideActionSheet();
      }, e.onEnter = function(i, s, r) {
        if (!i.ariaDisabled) {
          var f = i.className && i.className.indexOf("k-actionsheet-item") !== -1, p = s.elements.filter(function(h) {
            return h.className.indexOf("k-actionsheet-item") !== -1;
          });
          if (f && e.props.onItemClick) {
            r.preventDefault();
            var c = e.props.items[p.indexOf(i)];
            e.props.onItemClick.call(void 0, {
              syntheticEvent: r,
              item: c,
              title: c && c.title
            });
          }
          if (f && e.props.onItemSelect) {
            r.preventDefault();
            var c = e.props.items[p.indexOf(i)];
            e.props.onItemSelect.call(void 0, {
              syntheticEvent: r,
              item: c,
              title: c && c.title
            });
          }
          e.props.animation || e.hideActionSheet();
        }
      }, e.onEscape = function(i, s, r) {
        e.props.onOverlayClick && (r.preventDefault(), e.props.onOverlayClick.call(void 0, r)), e.props.onClose && (r.preventDefault(), e.props.onClose.call(void 0, r)), e.props.animation || e.hideActionSheet();
      }, e.hideActionSheet = function() {
        e.setState({ show: !1 });
      }, e.children = function(i) {
        var s = {};
        return o.Children.forEach(i, function(r) {
          r && (s[r.type.displayName] = r);
        }), s;
      }, e.state = {
        show: !1,
        slide: !1
      }, w(D), e;
    }
    return t.prototype.componentDidMount = function() {
      this.props.expand && !this.state.show && this.setState({ show: !0 });
    }, t.prototype.componentDidUpdate = function(a, e) {
      var i = this, s = this.actionSheetRef.current;
      if (this.props.expand && !this.state.show && this.setState({ show: !0 }), this.props.expand && this.state.show && !this.state.slide && this.setState({ slide: !0 }), !this.props.expand && this.state.show && this.state.slide && this.setState({ slide: !1 }), e !== this.state && this.state.slide && s && !this.props.className && (s.style.setProperty("--kendo-actionsheet-height", "auto"), s.style.setProperty("--kendo-actionsheet-max-height", "none")), s && this.props.navigatable) {
        var r = [
          ".k-actionsheet-footer",
          ".k-actionsheet-content",
          ".k-actionsheet-titlebar"
        ].map(function(p) {
          return P.concat(i.props.navigatableElements).map(function(c) {
            return "".concat(p, " ").concat(c);
          });
        }), f = K([
          ".k-actionsheet-item"
        ], r.flat(), !0);
        this.navigation = new j({
          tabIndex: this.props.tabIndex || 0,
          root: this.actionSheetRef,
          rovingTabIndex: !1,
          selectors: f,
          keyboardEvents: {
            keydown: {
              Tab: this.onTab,
              Enter: this.onEnter,
              Escape: this.onEscape
            }
          }
        }), this.navigation.focusElement(this.navigation.first, null);
      }
    }, t.prototype.render = function() {
      var a = this, e = this.props, i = e.title, s = e.subTitle, r = e.animationStyles, f = e.animation, p = e.expand, c = e.tabIndex, h = e.items, d = h == null ? void 0 : h.filter(function(u) {
        return !u.group || u.group === "top";
      }), y = h == null ? void 0 : h.filter(function(u) {
        return u.group === "bottom";
      }), A = d && d.length > 0 && y && y.length > 0, b = this.children(this.props.children), I = this.props.animationDuration || this.animationDuration, C = this.state.slide && o.createElement(
        "div",
        { className: v("k-actionsheet", this.props.className, {
          "k-actionsheet-bottom": !this.props.className
        }), role: "dialog", "aria-modal": "true", "aria-hidden": !1, "aria-labelledby": this.ariaLabeledBy, ref: this.actionSheetRef, onKeyDown: this.handleKeyDown },
        b[k] && !i && !s && b[k],
        (i || s) && o.createElement(
          "div",
          { className: "k-actionsheet-titlebar k-text-center" },
          o.createElement(
            "div",
            { className: "k-actionsheet-titlebar-group k-hbox" },
            o.createElement(
              "div",
              { className: this.actionSheetTitleClass, id: this.ariaLabeledBy },
              i && o.createElement("div", null, i),
              s && o.createElement("div", { className: "k-actionsheet-subtitle" }, s)
            )
          )
        ),
        b[_] || o.createElement(
          "div",
          { className: "k-actionsheet-content" },
          o.createElement("div", { className: "k-list-ul", role: "group" }, d && d.map(function(u, m) {
            return o.createElement(E, g({}, u, { id: m, key: m, item: u, tabIndex: c || 0, onClick: a.handleItemClick }));
          })),
          A && o.createElement("hr", { className: "k-hr" }),
          o.createElement("div", { className: "k-list-ul", role: "group" }, y && y.map(function(u, m) {
            return o.createElement(E, g({}, u, { id: m + ((d == null ? void 0 : d.length) || 0), key: m, item: u, tabIndex: c || 0, onClick: a.handleItemClick }));
          }))
        ),
        b[T]
      );
      return o.createElement(o.Fragment, null, p || this.state.show ? o.createElement(
        o.Fragment,
        null,
        o.createElement(
          "div",
          { className: "k-actionsheet-container" },
          o.createElement("div", { className: "k-overlay", onClick: this.handleOverlayClick }),
          f ? o.createElement(O, { transitionName: this.state.slide ? "slide-up" : "slide-down", onExited: this.hideActionSheet, transitionEnterDuration: I, transitionExitDuration: I, animationEnteringStyle: r || this.bottomPosition, animationEnteredStyle: r || this.bottomPosition, animationExitingStyle: r || this.bottomPosition, exit: !0, enter: !0, appear: !1 }, C) : C
        )
      ) : null);
    }, t.displayName = "KendoReactActionSheet", t.propTypes = {
      items: l.array,
      subTitle: l.string,
      title: l.string,
      navigatable: l.bool,
      navigatableElements: l.array
    }, t.defaultProps = {
      navigatable: !0,
      navigatableElements: []
    }, t;
  }(o.Component)
);
export {
  S as A,
  M as a,
  x as b,
  N as c
};
